export enum ROLES {
  Admin = 'ADMIN',
  User = 'USER'
};
